import React, { useEffect } from 'react';

import useFooterLines from '@hooks/Layout/UseFooterLines';
import useHeaderLines from '@hooks/Layout/UseHeaderLines';

import CustomSwitch from '@components/Gui/CustomSwitch';
import NwDivider from '@components/Gui/NwDivider';

export const DEFAULT_PRINT_LAYOUT_OPTION = {
    showCompanyHeader: true,
    showCompanyFooter: true,
    onlyLogoInHeader: false,
};

const PrintableLayoutOptionsSelector = ({ layoutOption, onLayoutOptionChange }) => {
    const headerLines = useHeaderLines();
    const footerLines = useFooterLines();
    const hasHeaderLines = headerLines.length > 0;
    const hasFooterLines = footerLines.length > 0;

    useEffect(() => {
        if (!hasHeaderLines && !layoutOption.onlyLogoInHeader) {
            onLayoutOptionChange({ onlyLogoInHeader: true });
        }
    }, [hasHeaderLines, layoutOption.onlyLogoInHeader, onLayoutOptionChange]);

    const { showCompanyHeader, showCompanyFooter, onlyLogoInHeader } = layoutOption;

    return (
        <>
            <NwDivider dark>Print Layout Options</NwDivider>
            <div className="switch-holder">
                <CustomSwitch
                    size="small"
                    value={showCompanyHeader}
                    text="show company header"
                    onChange={(checked) => onLayoutOptionChange({ showCompanyHeader: checked })}
                />
                {showCompanyHeader && (
                    <CustomSwitch
                        size="small"
                        value={hasHeaderLines ? onlyLogoInHeader : true}
                        text="only logo in header"
                        disabled={!hasHeaderLines}
                        onChange={(checked) => onLayoutOptionChange({ onlyLogoInHeader: checked })}
                    />
                )}
                {hasFooterLines && (
                    <CustomSwitch
                        size="small"
                        value={showCompanyFooter}
                        text="show company footer"
                        onChange={(checked) => onLayoutOptionChange({ showCompanyFooter: checked })}
                    />
                )}
            </div>
        </>
    );
};

export default PrintableLayoutOptionsSelector;
